import { COMPARE, COMPARE_KEYS } from './../../../types/@types/comparisons';
import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SearchCriterion, CriterionEvent, ICriterionComponent, SearchCriteriaRegistrant } from 'src/app/types/search-criteria';
import { Comparisons, COMPARESTR } from 'src/app/types/@types/comparisons';


export type DateKindsKind = 'days' | 'months';

export interface DateKinds {
	kind: DateKindsKind;
	months?: string;
	days?: string;
}

@Component({
	selector: 'app-date-kinds',
	templateUrl: './date-kinds.component.html',
	styleUrls: ['./date-kinds.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class DateKindsComponent implements OnInit, ICriterionComponent {

	public months = "";
	public days = "";
	public target: DateKindsKind = 'days';

	@Output()
	public registrantReady = new EventEmitter<SearchCriteriaRegistrant>();

	@Input()
	public field = '';

	@Output()
	public criteriaChange = new EventEmitter<CriterionEvent>();

	@Output()
	public valueChange = new EventEmitter<DateKinds>();

	@Input()
	get value(): DateKinds {
		const kinds: DateKinds = {
			kind: this.target
		}
		switch (this.target) {
			default:
			case 'days':
				kinds.days = this.days;//.slice(0);
				break;
			case 'months':
				kinds.months = this.months;//.slice(0);
				break;
		}
		return kinds;
	}
	set value(val: DateKinds) {
		if (!val) {
			this.target = 'days';
			return;
		}
		this.target = val.kind;
		if (!!val.months) {
			this.months = val.months;
		}
		if (!!val.days) {
			this.days = val.days;
		}
	}

  private _filtered:boolean = false;
  @Input()
  set filtered(f:boolean) {
    this._filtered = f;
    if(!!f && (this.target !== 'months')) {
      this.target = 'months';
    }
    this.Refresh();
  }
  get filtered():boolean {
    return this._filtered;
  }

	Update() {
		this.valueChange.emit(this.value);
		this.criteriaChange.emit({
			target: this,
			value: this.value,
			criterion: this.ToCriterion()
		});
	}

  private _ready = false;
	constructor(private cdr:ChangeDetectorRef) {

	}
	ngOnInit(): void {
		this.registrantReady.emit({ field: this.field, component: this })
    this._ready = true;
    this.Refresh();
	}
	ToCriterion(field?: string,operator?:any): SearchCriterion | null {
		if (!field) {
			field = this.field;
		}
		if (field === '') {
			return null;
		}
		const val = this.value;
    let compare = COMPARE.DATE_IS_ONE_OF;
    if(!operator) operator = COMPARE.DATE_IS_ONE_OF;
    if(operator === COMPARE_KEYS.NOT_IN) compare = COMPARE.DATE_IS_NOT_ONE_OF;
		const criterion: SearchCriterion = {
			field: (field + ':' + val.kind),
			compare: operator,
			value: (val.kind === 'days') ? val.days : val.months,
			modifier: val.kind,
			casting: 'date'
		}
		return criterion;
	}
  Refresh() {
    if(!this._ready) {
      this.cdr.detectChanges();
    }
  }

}

